var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13.5,
    fill: "#50B061"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.17 15.296l3.335 3.43.002.002c.121.122.35.235.582.235.227 0 .445-.11.624-.2l.015-.007.024-.012 6.307-6.69a.898.898 0 00-.001-1.258.898.898 0 00-1.261 0l-5.708 5.99-2.656-2.748-.002-.002a.898.898 0 00-1.26 0 .898.898 0 000 1.26zm3.746 3.492a.712.712 0 01-.303-.166l-3.336-3.431a.748.748 0 000 0l3.336 3.431a.713.713 0 00.303.166zm.173-1.786l5.814-6.1-5.813 6.1z",
    fill: "#fff"
  })));
}
export default SvgSuccess;